import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { Job } from '@app/models';
import { JobService } from '@app/services';

@Component({
    selector: 'jobs-nearby-list',
    templateUrl: './jobs-nearby-list.component.html',
    styleUrls: ['./jobs-nearby-list.component.scss'],
    standalone: false
})
export class JobsNearbyListComponent implements OnInit {
  @Input() jobsPassedIn;

  // Main data
  jobs: Job[] = [];
  isLoadingResults: boolean = false;

  totalItemsCount = 0;

  // Disable a search field
  jobTitleDisabled: boolean = false;

  // Used for title filter
  jobList = []; // Untouched list
  filteredJobTitles = []; // Filtered list
  titleDropdownFilter: string = null; // Inner title dropdown filter value
  professionFilter: string = null; // Selected profession filter value.

  constructor(
    public _router: Router,
    private _jobService: JobService
  ) {
    this.jobList = this._jobService.jobList;
  }

  ngOnInit() {
    this.filteredJobTitles = this.jobList; // Init filteredJobTitles with all job professions to start** 

    this.initJobList();
  }


  initJobList() {
    this.isLoadingResults = true;

    this.jobs = this.jobsPassedIn;
    this.totalItemsCount = this.jobsPassedIn.length;
    this.isLoadingResults = false;
  }


  applyFilters() {
    // console.log('Selected Profession: ', this.professionFilter);

    // If professionFilter is not null or empty then filter jos, else set to ones passed in.
    if (this.professionFilter && this.professionFilter !== '') {
      this.jobs = this.jobsPassedIn.filter(_job => _job.profession && _job.profession === this.professionFilter);
    } else {
      this.jobs = this.jobsPassedIn;
    }

    // const jobProfessions = [...this.jobsPassedIn].filter(_job => _job.profession != undefined).map(job => job.profession);
    // console.log("jobProfessions: ", jobProfessions);
  }


  async clearFilteredResults() {
    this.professionFilter = null;
    this.applyFilters();
  }


  public compareStringValuesFn(c1: any, c2: any) {
    return c1 && c2 && c1.toLowerCase() === c2.toLowerCase();
  }


  public compareJobListValuesFn(c1: any, c2: any) {
    return c1 && c2 ? c1['profession'] === c2['profession'] : c1 === c2;
  }


  // Apply value in select inner input to filter function.
  applyTitleDropdownFilter() {
    // console.log('Current Filter: ', this.titleDropdownFilter);
    this.filteredJobTitles = this.titleSearch(this.titleDropdownFilter);
  }


  // Filter the job list and send back to populate the filteredJobTitles**
  titleSearch(value: string) { 
    let filter = value.toLowerCase();
    return this.jobList.filter(option => (option.name && option.name.toLowerCase().includes(filter)) || (option.profession && option.profession.toLowerCase().includes(filter)));
  }


  // Reset title search select values when select closes
  titleDropdownSelectClose() {
    this.titleDropdownFilter = null;
    this.filteredJobTitles = this.jobList;
  }


  // Clear title select field values and apply the filter to get all jobs back.
  clearTitle(event: any) {
    event.stopPropagation();
    this.professionFilter = null;
    this.applyFilters();
  }


  sendToDetails(_job: Job) {
    if (_job.job_id && _job.job_id !== undefined) {
      this._jobService.setJobToBeViewed(_job);

      const professionForJobUrl = (_job.urlParts != undefined && _job.urlParts.profession != undefined) ? _job.urlParts.profession : null;
      const stateForJobUrl = (_job.urlParts != undefined && _job.urlParts.state != undefined) ? _job.urlParts.state : null;
      const cityForJobUrl = (_job.urlParts != undefined && _job.urlParts.city != undefined) ? _job.urlParts.city : null;
      const jobIdForJobUrl = (_job.job_id != undefined) ? _job.job_id : null;

      const jobLink = `jobs/${professionForJobUrl}/${stateForJobUrl}/${cityForJobUrl}/${jobIdForJobUrl}`;
      // this._router.navigate([jobLink]);

      document.location = jobLink;
    }
  }
}